module.exports = __webpack_public_path__ + "img/nav-search.b76ab29d.svg";